import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCheckCircle } = FiIcons;

export default function Services() {
  const services = [
    { title: "Premium suit & shirt fabrics", desc: "Curated selection from the world's finest mills." },
    { title: "Custom tailoring services", desc: "Bespoke fitting crafted to your exact measurements." },
    { title: "In-store consultation", desc: "Expert styling advice and fabric selection assistance." }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-serif text-gray-900 mb-4">We Provide</h2>
          <div className="w-16 h-1 bg-[#d4af37] mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {services.map((service, index) => (
            <div key={index} className="text-center p-6 border border-gray-100 hover:shadow-lg transition-shadow bg-[#faf9f6]">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#1a1a1a] text-[#d4af37] mb-6">
                <SafeIcon icon={FiCheckCircle} className="w-8 h-8" />
              </div>
              <h3 className="text-xl font-semibold mb-3 text-gray-900">{service.title}</h3>
              <p className="text-gray-600">{service.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}